// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"fff67182","59":"d8a59304","609":"ceded6cb","644":"2f92c5c7","724":"25436100"}[chunkId] + ".chunk.js";
};